import { createContext } from 'preact';

export const StreamContextStreamId = createContext(null);
